import { cn } from "@/lib/cn";

type Tone = "info" | "success" | "error" | "warning";

const toneClasses: Record<Tone, string> = {
  info: "bg-surface-card text-body-strong border-hairline",
  success: "bg-success/10 text-[#2f6b40] border-success/30",
  error: "bg-error/10 text-[#8a2e2e] border-error/30",
  warning: "bg-warning/10 text-[#8a6a10] border-warning/30",
};

export function Alert({ tone = "info", children }: { tone?: Tone; children: React.ReactNode }) {
  return (
    <div className={cn("rounded-md border px-4 py-3 text-sm", toneClasses[tone])} role="status">
      {children}
    </div>
  );
}
